import React from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
export function HeroSectionThemeSkeleton() {
    return (React.createElement(GridWrapper, { containerProps: {
            bgColor: colorCoreWhite1000,
            pt: '24px',
            pb: '24px',
        } },
        React.createElement(Skeleton, { skeletonProps: {
                height: 16,
                count: 4,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 14,
                count: 3,
                width: '30%',
            }, wrapperProps: {
                mtS: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 16,
                width: '50%',
            }, wrapperProps: {
                mtS: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 44,
            }, wrapperProps: {
                mtS: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 14,
            }, wrapperProps: {
                mtS: 24,
            } })));
}
